// extracted by mini-css-extract-plugin
export default {"subText":"TypeWriter_subText__EYd4X","typeWriterCursor":"TypeWriter_typeWriterCursor__JsOSa","typeWriterContainer":"TypeWriter_typeWriterContainer__J7jBU"};